import { loadable } from '@fiverr-private/perseus';
import { AB_TESTS_CATEGORY } from '../../../../constants';

const ABTestComponent = loadable(
    () => import(/* webpackChunkName: "ABTestComponent" */ './components/abTestComponent')
);

const ABTestGroup = loadable(() => import(/* webpackChunkName: "ABTestGroup" */ './components/abTestGroup'));

export const GROUP_NUMBERS = {
    A: 1,
    B: 2,
    C: 3,
    D: 4,
    E: 5,
};

const groupsConfig = Object.keys(GROUP_NUMBERS).map((groupKey) => ({
    component: ABTestGroup,
    options: {
        name: `Group ${groupKey}`,
        inputs: [
            {
                name: 'groupNumber',
                type: 'number',
                required: true,
                defaultValue: GROUP_NUMBERS[groupKey],
                helperText: 'Auto-set by Group component. Do not change!',
                showIf: () => false,
            },
        ],
    },
    noWrap: false,
    hasChildren: true,
}));

export const AB_TESTS_CONFIG = {
    components: [
        {
            component: ABTestComponent,
            options: {
                name: 'A/B Tests Wrapper',
                inputs: [
                    {
                        name: 'testNumber',
                        type: 'number',
                        required: false,
                    },
                    {
                        name: 'previewGroup',
                        type: 'enum',
                        defaultValue: '1',
                        enum: ['all', '1', '2', '3', '4', '5'],
                        required: false,
                    },
                ],
            },
            noWrap: false,
            hasChildren: true,
        },
        ...groupsConfig,
    ],
    category: AB_TESTS_CATEGORY,
};
